import { defineComponent as p, openBlock as l, createElementBlock as o, mergeProps as u, unref as e, renderSlot as g, createElementVNode as n, createCommentVNode as m } from "vue";
import { useScalarIcon as f } from "../hooks/useScalarIcon.js";
const h = { key: 0 }, k = { key: 1 }, A = { key: 2 }, M = { key: 3 }, Z = { key: 4 }, w = { key: 5 }, y = {
  name: "ScalarIconCaretRight"
}, L = /* @__PURE__ */ p({
  ...y,
  props: {
    label: {},
    weight: {}
  },
  setup(s) {
    const a = s, { bind: d, weight: r } = f(a);
    return (i, t) => (l(), o("svg", u({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(d)), [
      g(i.$slots, "default"),
      e(r) === "bold" ? (l(), o("g", h, t[0] || (t[0] = [
        n("path", { d: "M184.49,136.49l-80,80a12,12,0,0,1-17-17L159,128,87.51,56.49a12,12,0,1,1,17-17l80,80A12,12,0,0,1,184.49,136.49Z" }, null, -1)
      ]))) : e(r) === "duotone" ? (l(), o("g", k, t[1] || (t[1] = [
        n("path", {
          d: "M176,128,96,208V48Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M181.66,122.34l-80-80A8,8,0,0,0,88,48V208a8,8,0,0,0,13.66,5.66l80-80A8,8,0,0,0,181.66,122.34ZM104,188.69V67.31L164.69,128Z" }, null, -1)
      ]))) : e(r) === "fill" ? (l(), o("g", A, t[2] || (t[2] = [
        n("path", { d: "M181.66,133.66l-80,80A8,8,0,0,1,88,208V48a8,8,0,0,1,13.66-5.66l80,80A8,8,0,0,1,181.66,133.66Z" }, null, -1)
      ]))) : e(r) === "light" ? (l(), o("g", M, t[3] || (t[3] = [
        n("path", { d: "M180.24,132.24l-80,80a6,6,0,0,1-8.48-8.48L167.51,128,91.76,52.24a6,6,0,0,1,8.48-8.48l80,80A6,6,0,0,1,180.24,132.24Z" }, null, -1)
      ]))) : e(r) === "regular" ? (l(), o("g", Z, t[4] || (t[4] = [
        n("path", { d: "M181.66,133.66l-80,80a8,8,0,0,1-11.32-11.32L164.69,128,90.34,53.66a8,8,0,0,1,11.32-11.32l80,80A8,8,0,0,1,181.66,133.66Z" }, null, -1)
      ]))) : e(r) === "thin" ? (l(), o("g", w, t[5] || (t[5] = [
        n("path", { d: "M178.83,130.83l-80,80a4,4,0,0,1-5.66-5.66L170.34,128,93.17,50.83a4,4,0,0,1,5.66-5.66l80,80A4,4,0,0,1,178.83,130.83Z" }, null, -1)
      ]))) : m("", !0)
    ], 16));
  }
});
export {
  L as default
};
